module.exports = __webpack_public_path__ + "img/backspace.38a48f5d.svg";